/**
 * Checks if the current URL contains IdP-initiated flow tokens
 *
 * IdP-initiated flows return tokens in the hash (implicit flow) instead of
 * a code parameter in the query string. This function detects that scenario.
 *
 * @returns true if the URL contains access_token and id_token in the hash but no code in the query
 */
export function isIdpInitiatedFlow(): boolean {
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const searchParams = new URLSearchParams(window.location.search);

  return (
    hashParams.has('access_token') &&
    hashParams.has('id_token') &&
    !searchParams.has('code')
  );
}
